<template>
    <el-col>        
        <div >
            <el-row v-if="!isSimplePage" class="top-action-bar">
                <el-button v-if="this.addNewSourceForm.canEdit==1 && simpleGongDanUrl" @click="onSimpleCopy(simpleGongDanUrl)">复制工单链接</el-button>
                <el-button v-if="this.addNewSourceForm.canEdit==1 && simpleGongDanUrl" @click="onExtendToken" type="warning" size="small">调整链接有效期</el-button>
                <el-button v-if="showWenjuan && wenjuanUrl"  @click="onSimpleCopy(wenjuanUrl)">复制问卷链接</el-button>
            </el-row>
            <div v-if="!isMobile" class="back-btn-row">
                <el-button @click="onGoback" type="danger">{{isSimplePage?'关闭页面':'返回'}}</el-button>
            </div>
                    <div class="section">
                        <span class="title"><i class="el-icon-document"></i> 工单简介</span>
                    </div>
                    <div class="card-container">
                        <el-row style="margin-left: 50px;margin-top:20px;">
                        <el-form :inline="true" :model="addNewSourceForm" :label-width="isMobile?'70px':'100px'" :style="isMobile?'margin-left: -40px;':''" label-position="left">
                            <el-descriptions class="margin-top" :label-style="labelStyle" title="" :column="isMobile?1:2" border>
                                <template slot="extra">

                                </template>
                                <el-descriptions-item v-if="!isSimplePage">
                                    <template slot="label">
                                        通话编号
                                    </template>
                                    <el-input :readonly="!editMain" v-model="addNewSourceForm.sessionCode" ></el-input>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        工单编号
                                    </template>
                                    <el-input  :readonly="!editMain" v-model="addNewSourceForm.sheetCode" ></el-input>
                                </el-descriptions-item>
                                <el-descriptions-item v-if="!isSimplePage">
                                    <template slot="label">
                                        工单类型
                                    </template>
                                    <!-- <div v-if="!editMain" class="label_value">{{addNewSourceForm.sheetType}}</div> -->
                                    <el-cascader  :disabled="!editMain"
                                        :options="typeList"
                                        :props="props"
                                        v-model="addNewSourceForm.sheetTypeIds"
                                        clearable></el-cascader>    
                                </el-descriptions-item>
                                <el-descriptions-item v-if="!isSimplePage">
                                    <template slot="label">
                                        紧急程度
                                    </template>
                                    <!-- <div v-if="!editMain" class="label_value">{{addNewSourceForm.alertValue}}</div> -->
                                    <el-select :disabled="!editMain" v-model="addNewSourceForm.alertLevel" clearable placeholder="请选择">
                                        <el-option
                                            v-for="item in gradeList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-descriptions-item>
                                <el-descriptions-item v-if="!isSimplePage">
                                    <template slot="label">
                                        公司类型
                                    </template>
                                    <!-- <div v-if="!editMain" class="label_value">{{addNewSourceForm.companyType}}</div>                                     -->
                                    <el-select :disabled="!editMain" placeholder="请选择公司类型" v-model="addNewSourceForm.companyType" clearable >
                                        <el-option
                                            v-for="item in companyTypeList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-descriptions-item>
                                <el-descriptions-item v-if="!isSimplePage">
                                    <template slot="label">
                                        公司名称
                                    </template>
                                    <!-- <div v-if="!editMain" class="label_value">{{addNewSourceForm.companyName}}</div> -->
                                    <el-input :readonly="!editMain" v-model="addNewSourceForm.companyName" placeholder="请输入公司类型"></el-input>
                                </el-descriptions-item>
                                <el-descriptions-item  v-if="!isSimplePage && addNewSourceForm.companyType == '最终用户'">
                                    <template slot="label">
                                        经销商名称
                                    </template>
                                    <!-- <div v-if="!editMain" class="label_value">{{addNewSourceForm.jxsName}}</div> -->
                                    <el-input :readonly="!editMain" v-model="addNewSourceForm.jxsName"  placeholder="请输入经销商名称"></el-input>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        联系人
                                    </template>
                                    <!-- <div v-if="!editMain" class="label_value">{{addNewSourceForm.contactUser}}</div> -->
                                    <el-input :readonly="!editMain"  v-model="addNewSourceForm.contactUser" ></el-input>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        联系电话
                                    </template>
                                    <!-- <div v-if="!editMain" class="label_value">{{addNewSourceForm.tel}}</div> -->
                                    <el-input :readonly="!editMain" v-model="addNewSourceForm.tel" ></el-input>
                                </el-descriptions-item>
                                <el-descriptions-item v-if="!isSimplePage">
                                    <template slot="label">
                                        邮箱
                                    </template>
                                    <!-- <div v-if="!editMain" class="label_value">{{addNewSourceForm.email}}</div> -->
                                    <el-input :readonly="!editMain" v-model="addNewSourceForm.email" ></el-input>
                                </el-descriptions-item>
                                <el-descriptions-item v-if="!isSimplePage">
                                    <template slot="label">
                                        地址
                                    </template>
                                    <!-- <div v-if="!editMain" class="label_value">{{addNewSourceForm.address}}</div> -->
                                    <el-input :readonly="!editMain" v-model="addNewSourceForm.address" ></el-input>
                                </el-descriptions-item>
                                <el-descriptions-item span="2" v-if="!isSimplePage">
                                    <template slot="label">
                                        网域名称
                                    </template>
                                    <!-- <div v-if="!editMain" class="label_value">{{addNewSourceForm.account}}</div> -->
                                    <el-input :readonly="!editMain" v-model="addNewSourceForm.account" ></el-input>
                                </el-descriptions-item>

                                <el-descriptions-item style="margin-top:0rem;" span="2">
                                    <template slot="label">
                                        工单主题
                                    </template>
                                    <!-- <div v-if="!editMain" class="label_value">{{addNewSourceForm.title}}</div>
                                    <div v-else> -->
                                        <el-input  :readonly="!editMain" v-model="addNewSourceForm.title"></el-input>
                                    <!-- </div> -->
                                </el-descriptions-item>
                                <el-descriptions-item span="2">
                                    <template slot="label">
                                        工单内容
                                    </template>
                                    <WangEditorControl
                                        v-model="addNewSourceForm.content"
                                        :readonly="!editMain"
                                        placeholder="请输入工单内容"
                                        :height="300"
                                    />
                                </el-descriptions-item>
                                <el-descriptions-item v-if="!isSimplePage && (editMain ||(!editMain && addNewSourceForm.sample && addNewSourceForm.sample.length>0))" span="2">
                                    <template slot="label">
                                        附件
                                    </template>
                                    <my-upload-file-form-item v-model="addNewSourceForm.sample" label="" :limit="10" :multiple="true" :disabled="!editMain" />
                                </el-descriptions-item>
                                <!-- <el-descriptions-item>
                                    <template slot="label">
                                        
                                    </template>
                                    
                                </el-descriptions-item> -->
                            </el-descriptions>


                            <!-- <el-row  class="companyRow">
                                <el-col :span="12">
                                    <el-form-item label="通话编号">
                                        <div v-if="!editMain" class="label_value">{{addNewSourceForm.sessionCode}}</div>
                                        <el-input v-else v-model="addNewSourceForm.sessionCode" ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="工单编号">
                                        <div v-if="!editMain" class="label_value">{{addNewSourceForm.sheetCode}}</div>
                                        <el-input v-else v-model="addNewSourceForm.sheetCode" ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="工单类型">
                                        <div v-if="!editMain" class="label_value">{{addNewSourceForm.sheetType}}</div>
                                        <el-cascader v-else
                                            :options="typeList"
                                            :props="props"
                                            v-model="addNewSourceForm.sheetTypeIds"
                                            clearable></el-cascader>                                   
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="紧急程度">
                                        <div v-if="!editMain" class="label_value">{{addNewSourceForm.alertValue}}</div>
                                        <el-select v-else v-model="addNewSourceForm.alertLevel" clearable placeholder="请选择">
                                            <el-option
                                                v-for="item in gradeList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                            
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row  class="companyRow">
                                <el-form-item  label="公司类型">
                                    <div v-if="!editMain" class="label_value">{{addNewSourceForm.companyType}}</div>                                    
                                    <el-select  v-else :style="isMobile?'width: 100%;':'width: 800px;'" placeholder="请选择公司类型" v-model="addNewSourceForm.companyType" clearable >
                                        <el-option
                                            v-for="item in companyTypeList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>   
                            </el-row>
					        <el-row  class="companyRow">
                                <el-form-item  label="公司名称">
                                    <div v-if="!editMain" class="label_value">{{addNewSourceForm.companyName}}</div>
                                    <el-input v-else v-model="addNewSourceForm.companyName"  :style="isMobile?'width: 80%;':'width:800px;'" placeholder="请输入公司类型"></el-input>
                                </el-form-item>  
                            </el-row>
                            <el-row  v-if="addNewSourceForm.companyType == '最终用户'" class="companyRow">
                                <el-form-item  label="经销商名称">
                                    <div v-if="!editMain" class="label_value">{{addNewSourceForm.jxsName}}</div>
                                    <el-input v-else v-model="addNewSourceForm.jxsName"  :style="isMobile?'width: 80%;':'width:800px;'" placeholder="请输入公司类型"></el-input>
                                </el-form-item>  
                            </el-row>
                            <el-row  class="companyRow">
                                <el-form-item  label="联系人　">
                                    <div v-if="!editMain" class="label_value">{{addNewSourceForm.contactUser}}</div>
                                    <el-input style='width: 800px;'  v-else v-model="addNewSourceForm.contactUser" ></el-input>
                                </el-form-item>   
                            </el-row>
					        <el-row  class="companyRow">
                                <el-form-item  label="联系电话">
                                    <div v-if="!editMain" class="label_value">{{addNewSourceForm.tel}}</div>
                                    <el-input style='width: 800px;'  v-else v-model="addNewSourceForm.tel" ></el-input>
                                </el-form-item> 
                            </el-row>
					        <el-row  class="companyRow">
                                <el-form-item  label="邮　　箱">
                                    <div v-if="!editMain" class="label_value">{{addNewSourceForm.email}}</div>
                                    <el-input style='width: 800px;'  v-else v-model="addNewSourceForm.email" ></el-input>
                                </el-form-item> 
                            </el-row>
                            <el-row  class="companyRow">    
                                <el-form-item  label="地　　址">
                                    <div v-if="!editMain" class="label_value">{{addNewSourceForm.address}}</div>
                                    <el-input style='width: 800px;'  v-else v-model="addNewSourceForm.address" ></el-input>
                                </el-form-item>     
                            </el-row>
                            <el-row  class="companyRow"> 
                                <el-form-item  label="网域名称">
                                    <div v-if="!editMain" class="label_value">{{addNewSourceForm.account}}</div>
                                    <el-input style='width: 800px;'  v-else v-model="addNewSourceForm.account" ></el-input>
                                </el-form-item>    
   
                            </el-row>

                            <el-row>
                                <el-form-item  label="工单主题">
                                    <div v-if="!editMain" class="label_value">{{addNewSourceForm.title}}</div>
                                    <div v-else>
                                        <el-input style="width:800px;" v-model="addNewSourceForm.title"></el-input>
                                    </div>
                                </el-form-item>                       
                            </el-row>
                            
                            <el-row  style="margin-top:-0px;">
                                <el-form-item class="remark" label="工单内容" style="width: 100%;margin-top:0px;">
                                    <el-col :span="24">
                                        <div v-if="!editMain" class="label_value">
                                            <el-input :readonly="true" v-model="addNewSourceForm.content" size="medium" :rows="8" type="textarea"
                                            autocomplete="off" placeholder="" style="width:90%"
                                            ></el-input>
                                        </div>
                                        <div v-else>
                                            <el-input v-model="addNewSourceForm.content" size="medium" :rows="8" type="textarea"
                                            autocomplete="off" placeholder="请输入工单内容" style="width:90%"
                                            ></el-input>
                                        </div>
                                    </el-col>
                                </el-form-item>                     
                            </el-row>
                            <el-row v-if="editMain ||(!editMain && addNewSourceForm.sample && addNewSourceForm.sample.length>0)">
                                <my-upload-file-form-item v-model="addNewSourceForm.sample" label="附件" :limit="10" :disabled="!editMain" />
                            </el-row> -->

                            <el-row v-if="canEdit" class="form-btn-row">
                                <el-button type="primary" @click="onMainEdit">{{btnMainLabel}}</el-button>
                                <el-button v-if="editMain" type="primary" @click="onMainCancel">取消</el-button>
                            </el-row>

                        </el-form>
                    </el-row>
                    </div>
                    <div class="section">
                        <span class="title"><i class="el-icon-s-tools"></i> 工单处理</span>
                    </div>
                    <div class="card-container">
                        <el-row  style="margin-left: 10px;">
                            <el-form label-width="500px;" :model="addNewSourceForm" label-position="left">
                                <el-descriptions class="margin-top" :label-style="labelStyle" title="" size="mini" :column="1" border>
                                    <template slot="extra">
                                        <div style="display:flex;">
                                            
                                        </div>
                                    </template>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            回复内容
                                        </template>
                                        <WangEditorControl
                                                    v-model="addNewSourceForm.reply"
                                                    :readonly="weitijiaotj==0 || !canReply"
                                                    placeholder="请输入回复内容"
                                                    :height="250"
                                                />
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            附件
                                        </template>
                                        <my-upload-file-form-item v-model="addNewSourceForm.sampleLog" label=""  :disabled="weitijiaotj==0 || !canReply" :limit="10" />
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            升级21V
                                        </template>
                                        <el-switch :disabled="weitijiaotj==0 || !canReply" v-model="addNewSourceForm.to21V" @change="forceUpdate()"></el-switch>&nbsp;&nbsp;&nbsp;{{ addNewSourceForm.to21V?'是':'否' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item v-if="addNewSourceForm.to21V">
                                        <template slot="label">
                                            问题分类
                                        </template>
                                        <el-select :disabled="weitijiaotj==0 || !canReply" placeholder="请选择问题分类" v-model="addNewSourceForm.cateId" clearable @change="changeWtfl()">
                                            <el-option
                                                v-for="item in cate21VList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-descriptions-item>
                                </el-descriptions> 

                                <el-divider  v-if="addNewSourceForm.to21V && addNewSourceForm.code21V.length>0" content-position="center">21V信息</el-divider>

                                <el-descriptions v-if="addNewSourceForm.to21V && addNewSourceForm.code21V.length>0"  size="mini" :column="1" border> 
                                    <el-descriptions-item>
                                        <template slot="label">
                                            21V工单号
                                        </template>
                                        <el-input :readonly="weitijiaotj==0 || !canReply" v-model="addNewSourceForm.code21V" style="width:80%;" @input="forceUpdate()" placeholder="请输入21V工单号"></el-input>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            21V处理方案
                                        </template>
                                        <editor name="editor" style="height: 100%;" ref="editor"/>
                                    </el-descriptions-item>
                                </el-descriptions> 
                            </el-form>    
                        </el-row>
                        <el-row class="submit-btn-row">
                        <!-- <div style="margin-bottom: 20px;margin-top:1rem;text-align: center;"> -->
                            <el-button v-if="canReply" type="primary" @click="onSubEdit">{{btnSubModifyLabel}}</el-button>
                            <el-button v-if="!canReply" type="primary" @click="onSub21VResult">保存21V处理方案</el-button>
                            <el-button v-if="!isSimplePage" type="danger" @click="onGoback">返回</el-button>
                            <el-button v-else type="danger" @click="onGoback">关闭页面</el-button>
                        <!-- </div> -->
                        </el-row>
                    </div>

        </div>

    </el-col>
</template>

<script>
import {mapGetters} from "vuex";
import {getWorkSheetDetail,getWorkSheetDetailSub,getWorkSheetDetailUrl,getWorkSheetDetailAll2024,ExtendGuestTokenExpire} from "@/api/workSheet";
import {getToken} from "@/utils/auth";
import RightBack from "@/components/RightBack";
import CommonBack from "@/components/CommonBack";
import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";
import {getCurrentYMD} from "@/utils/time";
import {encrypt} from "@/utils/encrypt";
import {getSampleStrToSever} from "@/views/WorkSheet/xml-manager";
import Editor from 'wangeditor';
import WangEditorControl from '@/components/WangEditorControl';
import {isEmptyHtml} from '@/utils/html';

    export default {
        name: "flowView",
		components: {RightBack,MyUploadFileFormItem,WangEditorControl},//,todoItem,  SourcePrice
		props: ['Id'],
        computed: {...mapGetters(['groupUserList','typeList','gradeList','statusList','isMobile','cate21VList'])},
        data() {
            return {
                gongdanUrl:'',
                wenjuanUrl:'',
                simpleGongDanUrl:'',
                list:[],
                canEdit:0,
                canReply:0,
                weitijiaotj:1,
                btnMainLabel:'修改',
                btnSubModifyLabel:'修改',
                editMain:false,
                // modifySub:false,
                addNewSourceForm: {
						id:'',
						sessionCode: '',
						sheetCode: '',
						sheetTypeIds:[],
						title: '',                        
						content:'',
                        toUIds:[],
						ccUIds:[],
						flowtype:'1',
						alertLevel:11,
						itemContent:'',
						status:'',
                        canEdit:0,
                        reply:'',
                        finished:0,

                        companyType:'',
						companyName:'',
						contactUser:'',
						tel:'',
						address:'',
						email:'',
                        account:'',
                        to21V:false,
                        cateId:'',
                        code21V:'',
                        result21V:'',
                        sample21VLog:[],
                        sample: [],
                        sampleLog: []
					},
                props: { multiple: true },
                showWenjuan:false,
                companyTypeList:[{label:'',value:''},{label:'经销商',value:'经销商'},{label:'最终用户',value:'最终用户'}],
                isChange:false,
                isSimplePage:true,
                userId:0,

                labelStyle: {
							'color': '#000',
							'text-align': 'center',
							'font-weight': '600',
							'height': '40px',
							// 'background-color': 'rgba(255, 97, 2, 0.1)',
							// 'min-width': '110px',
							// 'max-width': '150px',
							'width': '110px',
							'word-break': 'keep-all'
						},
                editor:{},
            }

        },
        async mounted() {
            if (this.$route.query.token){
                this.userId = getToken()
            }else{
                this.userId = getToken()
                this.isSimplePage = false
            }
            console.log(this.$route,window.location.href)
            await this.$store.dispatch('workSheet/groupUserList',{userId:this.userId});
            await this.$store.dispatch("workSheet/typeList",{userId:this.userId});
            await this.$store.dispatch("workSheet/statusList", {userId:this.userId});
            await this.$store.dispatch("workSheet/gradeList", {userId:this.userId});
            await this.$store.dispatch("workSheet/cate21VList", {userId:this.userId});
            // console.log('cate21VList',this.cate21VList)
            this.$store.dispatch("setting/checkDevice");
            var li = localStorage.getItem('loginInfo')
            if (li){
                if (JSON.parse(localStorage.getItem('loginInfo')).roleId=='1' || JSON.parse(localStorage.getItem('loginInfo')).roleId=='9'){
                    // console.log('1111')
                    this.showWenjuan=true;
                }else{
                    // console.log('2222')
                }                
            }
            // console.log('this.isSimplePage',this.isSimplePage,this.Id)
            

            this.initData2024();

            
        },
        methods: {
            async initChangeFlag(){
                this.isChange = false
            },
            
            forceUpdate(){
                this.$forceUpdate()
                // val = !val
                // console.log(val)
            },
            changeWtfl(){
                this.$forceUpdate()
            },
            async initData2024(){
                // console.log('initData',this.Id)
                if (this.Id) {
                    const {data} = await getWorkSheetDetailAll2024({userId: this.userId, Id: this.Id, isGuest: this.isSimplePage});
                    console.log('data',data)
                    console.log('main.sample',data.main.sample)
                    console.log('sub.obj[0].sampleLog',data.sub.obj.length>0?data.sub.obj[0].sampleLog:'no sub records')
                    this.addNewSourceForm = data.main;
                    this.addNewSourceForm.userId = this.userId
                    if (data.sub.obj.length>0){
                        this.addNewSourceForm.to21V=data.sub.obj[0].to21V
                        this.addNewSourceForm.cateId = data.sub.obj[0].cateId
                        this.addNewSourceForm.code21V = data.sub.obj[0].code21V?data.sub.obj[0].code21V:''
                        this.addNewSourceForm.result21V = data.sub.obj[0].result21V?data.sub.obj[0].result21V:''
                        this.addNewSourceForm.sample21VLog = data.sub.obj[0].sample21VLog
                        this.addNewSourceForm.sampleLog = data.sub.obj[0].sampleLog
                        this.addNewSourceForm.reply = data.sub.obj[0].itemContent?data.sub.obj[0].itemContent:''
                        this.addNewSourceForm.logId = data.sub.obj[0].id
                    }else{
                        this.addNewSourceForm.to21V = false
                        this.addNewSourceForm.cateId = ''
                        this.addNewSourceForm.code21V = ''
                        this.addNewSourceForm.result21V = ''
                        this.addNewSourceForm.sample21VLog = []
                        this.addNewSourceForm.sampleLog = []
                        this.addNewSourceForm.reply = ''
                        this.addNewSourceForm.logId = 0
                    }
                    //console.log('this.editor',this.editor)
                    if (this.addNewSourceForm.code21V !== ''){
                        setTimeout(()=>{
                            console.log('123')
                            if (this.editor.id){
                                this.editor.destroy()
                            }
                            var editor = new Editor(this.$refs.editor);
                            this.editor = editor;
                            // const editorConfig = {};
                            // editorConfig.placeholder = '请输入内容';
                            editor.config.uploadImgShowBase64 =true
                            editor.create();
                            this.editor.cmd.do('insertHTML', this.addNewSourceForm.result21V);
                            // console.log('sss',this.editor.txt.html())
                            if (this.canReply !== 1){
                                // this.editor.disable()
                            }
                        },2000)
                        
                    }
                    // console.log('this.addNewSourceForm',this.addNewSourceForm)
                    if (this.addNewSourceForm.canEdit==1){
                        this.canEdit=1;
                    }
                    if (this.addNewSourceForm.canReply==0 || !this.addNewSourceForm.canReply){
                        this.canReply=0;
                    }else{
                        this.canReply=1;
                    }

                    if (this.canReply == 1){
                        this.btnSubModifyLabel="提交";
                        // this.modifySub=true;
                    }else{
                        // console.log('this.editor',this.editor)
                        // if (this.addNewSourceForm.code21V !== ''){
                        //     this.editor.disable()
                        // }
                    }

                    this.list = data.sub.obj;
                    // console.log('this.list',this.list)
                    // console.log('canReply',this.canReply)
                    // console.log('dataUrl',dataUrl)
                    this.gongdanUrl = data.url.obj[0].urls;
                    this.simpleGongDanUrl = data.url.obj[0].simpleurls
                    this.wenjuanUrl = data.url.obj[0].wenjuanurls;
                    // 对于通过链接访问的访客页面，清除无关敏感字段，仅保留 工单编号/联系人/联系电话
                    if (this.isSimplePage) {
                        this.addNewSourceForm.sessionCode = '';
                        this.addNewSourceForm.sheetTypeIds = [];
                        this.addNewSourceForm.sheetType = '';
                        this.addNewSourceForm.companyType = '';
                        this.addNewSourceForm.companyName = '';
                        this.addNewSourceForm.jxsName = '';
                        this.addNewSourceForm.address = '';
                        this.addNewSourceForm.email = '';
                        this.addNewSourceForm.account = '';
                        this.addNewSourceForm.alertLevel = '';
                        this.addNewSourceForm.alertValue = '';
                        this.addNewSourceForm.status = '';
                        this.addNewSourceForm.toUIds = '';
                        this.addNewSourceForm.ccUIds = '';
                        this.addNewSourceForm.sample = '';
                    }
                    // 调试：打印复制工单链接按钮的显示条件
                    // console.log('[按钮显示条件] canEdit:', this.addNewSourceForm.canEdit, '| simpleGongDanUrl:', this.simpleGongDanUrl, '| isSimplePage:', this.isSimplePage);
                    // console.log('bbb',this.list)
                    // this.list = data[1];
                    
                }
            },

            async onMainEdit(){
                if (!this.editMain){
                    this.btnMainLabel="保存";
                    this.editMain=true;
                }else{
                    // if (!this.addNewSourceForm.content || this.addNewSourceForm.content.length==0){
                    if (isEmptyHtml(this.addNewSourceForm.content)) {
                        this.$message.warning('请填写工单内容！')
						return;
                    }
					await this.$store.dispatch('workSheet/SaveWorkSheetMain', {form: this.addNewSourceForm});
					this.$message.success('编辑成功');
                    // this.initData();
                    this.initData2024();
                    this.isChange = true;
                    this.btnMainLabel="修改";
                    this.editMain=false;
                }
            },

           async onGoback(){
                // console.log('this.isChange',this.isChange)
                if (this.isSimplePage){
                    // await this.$confirm('确认关闭当前页面？', '关闭', {
                    //     confirmButtonText: '确定',
                    //     cancelButtonText: '取消',
                    //     type: 'warning'
                    // });
                    // try {
                        if (this.editor.id){
                            this.editor.destroy();
                        }
                        window.location.href="about:blank";
                        window.close()
                    // } catch (e) {
                        
                    // }
                }else{
                    if (this.editor.id){
                        this.editor.destroy();
                    }
                    if (window.location.href.includes('SheetViewParent')){
                        this.$router.push({path: '/WorkSheet/Index/2', query: ''})
                    }else{
                        this.$emit('onclose',this.isChange)
                    }
                    // this.$emit('onclose',this.isChange)
                }
                
            },

            onSubModifyCancel(){
                this.btnSubModifyLabel="修改";
                // this.modifySub=false;
            },

            async onSub21VResult(){
                var obj = JSON.parse(JSON.stringify(this.addNewSourceForm))
                try{
                    obj.result21V = this.editor.txt.html()
                }catch{
                    obj.result21V=''
                }
                this.$store.dispatch('workSheet/Save21VResult', {
                            logId:obj.logId,                            
                            result21V:obj.result21V,
                            userId:this.userId
                        }).then(()=>{
                            this.$message.success('提交成功');
                            if (!this.isSimplePage){
                                this.initData2024();
                                this.canReply=0;
                                this.weitijiaotj=0;
                                this.isChange = true;

                                this.onGoback()

                            }else{
                                this.weitijiaotj=0;
                                this.onSubModifyCancel()
                            }
                        })

            },

            async onSubEdit(){
                if (this.btnSubModifyLabel=='修改'){
                    this.btnSubModifyLabel='提交' 
                    this.weitijiaotj=1
                }else{
                var obj = JSON.parse(JSON.stringify(this.addNewSourceForm))
                try{
                    obj.result21V = this.editor.txt.html()
                }catch{
                    obj.result21V=''
                }
                
                    if (!obj.to21V && isEmptyHtml(obj.reply)){
                        this.$message.warning('请填写回复内容！')
						return;
                    }
                    if (obj.to21V && !obj.cateId){
                        this.$message.warning('请选择问题分类！')
						return;
                    }
                    // console.log('reply',this.addNewSourceForm.reply)
                    if (obj.to21V && isEmptyHtml(obj.reply)){
                        // console.log('dd')
                        obj.reply = '升级21V'
						
                    }
                    // console.log('this.addNewSourceForm.sample21VLog',this.addNewSourceForm.sample21VLog)
                    console.log('【保存】sampleLog 原始数组:', JSON.stringify(obj.sampleLog));
                    console.log('【保存】sampleLog 转为字符串:', obj.sampleLog?.map(item => item.name).join(';') ?? '');

                    this.$store.dispatch('workSheet/SaveWorkSheetSub2024', {
                            logId:obj.logId,
                            wsId:this.Id,
                            // status:this.addNewSourceForm.status,
                            finished:obj.finished,
                            itemContent:obj.reply,
                            sampleLog:obj.sampleLog,
                            to21V:obj.to21V,
                            cateId:obj.cateId,
                            code21V:obj.code21V,
                            result21V:obj.result21V,
                            sample21VLog:obj.sample21VLog,
                            userId:this.userId
                        }).then(()=>{
                            this.$message.success('提交成功');
                            // this.initData();
                            if (!this.isSimplePage){
                                this.initData2024();
                                this.canReply=0;
                                this.weitijiaotj=0;
                                this.isChange = true;
                                // console.log('aaaaaaaaaa',window.location.href)
                            
                                // if (window.location.href.includes('SheetViewParent')){
                                //     this.$router.push({path: '/WorkSheet/Index/2', query: ''})
                                // }else{
                                    this.onGoback()
                                // }
                            }else{
                                this.weitijiaotj=0;
                                this.onSubModifyCancel()
                                // window.location.href="about:blank";
                                // windows.close()
                            }
                        })
                        
                        
                        // 
                        // this.$router.go(-1);
                // }

               


					// await this.$store.dispatch('workSheet/SaveWorkSheetSub', {
                    //     logId:0,
                    //     wsId:this.Id,
                    //     status:this.addNewSourceForm.status,
                    //     itemContent:this.addNewSourceForm.reply
                    // });
					// this.$message.success('回复成功');
                    // this.initData();
                    }
            },

            onMainCancel(){
                this.btnMainLabel="修改";
                this.editMain=false;
            },

            onSimpleCopy(text){
                // console.log('text',text)
                var myTagContent = document.createElement("input");
                document.body.appendChild(myTagContent);
                myTagContent.value = text;
                myTagContent.select();
                document.execCommand("copy");
                myTagContent.remove();

                // // var input = document.getElementById("t_"+obj);
                // input.value = text; // 修改文本框的内容
                // input.select(); // 选中文本
                // document.execCommand("copy"); // 执行浏览器复制命令
                alert("复制成功");
                // Toast('复制成功')

            },

            // 续期访客链接（管理员操作）
            onExtendToken(){
                var self = this;
                // 从 simpleGongDanUrl 中提取 token 参数
                var tokenMatch = self.simpleGongDanUrl.match(/[?&]token=([^&\s]+)/);
                if (!tokenMatch || !tokenMatch[1]) {
                    self.$message.error('未找到有效的链接token');
                    return;
                }
                var fullToken = tokenMatch[1];

                self.$prompt('请输入续期天数（默认30天）', '设置链接有效期', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputType: 'number',
                    inputValue: 30,
                    inputValidator: function(val) {
                        var days = parseInt(val);
                        if (isNaN(days) || days <= 0 || days > 365) {
                            return '请输入1-365之间的天数';
                        }
                        return true;
                    }
                }).then(function({ value }) {
                    var extendDays = parseInt(value) || 30;
                    ExtendGuestTokenExpire({fullToken: fullToken, extendDays: extendDays}).then(function(res) {
                        if (res.code === 1) {
                            self.$message.success(res.data?.Msg || '链接有效期已设为' + extendDays + '天');
                        } else {
                            self.$message.error(res.data?.Msg || '设置失败，请重试');
                        }
                    }).catch(function(err) {
                        self.$message.error('设置失败: ' + (err.message || '网络错误'));
                    });
                }).catch(function() {
                    // 用户取消，不提示
                });
            },

            onCopy: function (e) {
                // Promise.all(this.list.map(function(elem){
                //     return new Promise(function(resolve, reject){
                //         var uids = elem.toUIds?.split(';');

                //         var counter = 0;
                //         uids.forEach(function(uid){
                //             //异步回调中
                //             counter++;
                //             if(counter === arr.length){
                //                 //在这执行所有执行的完后的
                //             }
                //         });

                //         resolve(result);
                //     })
                // })).then(function(data){

                //在这就可以等所有的返回结果可以得到

                // })


                // var token=encrypt(getToken())+'_'+encrypt(getCurrentYMD());

                // this.gongdanUrl = `http://ccenter.langyuntech.com/#/WorkSheet/SheetViewParent/${this.Id}?token=${token}`
                // console.log('this.gongdanUrl',this.gongdanUrl)

                this.$alert(this.gongdanUrl, '邮件工单地址', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    customClass:'message_box_alert'
                });

                // alert('请拷贝到剪贴板，然后在邮件中加入此超链'+"\n"+this.gongdanUrl)
            },
            onwenjuanCopy: function (e) {                
                this.$alert(this.wenjuanUrl, '问卷地址', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    customClass:'message_box_alert'
                });

                // alert('请拷贝到剪贴板，然后在邮件中加入此超链'+"\n"+this.gongdanUrl)
            },

            onError: function (e) {
                console.log(e)
                alert('Failed to copy texts')
            }


        }
    }
</script>

<style scoped>

/* ========== Card Container ========== */
.card-container {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    padding: 24px 20px;
    margin: 16px 0 24px;
    border: 1px solid #ebeef5;
    transition: box-shadow 0.3s ease;
}
.card-container:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* ========== Section Headers ========== */
.section {
    position: relative;
    width: 100%;
    height: 48px;
    background: linear-gradient(135deg, #409eff 0%, #337ecc 100%);
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding-left: 18px;
    margin: 8px 0 20px;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
}
.section::before {
    content: '';
    position: absolute;
    left: 0;
    top: 8px;
    bottom: 8px;
    width: 4px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 0 2px 2px 0;
}
.section .title {
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    letter-spacing: 1px;
    display: flex;
    align-items: center;
    gap: 8px;
}
.section .title i {
    font-size: 18px;
    color: #ffd04b;
}

/* ========== Top Action Bar ========== */
.top-action-bar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    margin-top: -3rem;
    flex-wrap: wrap;
}
.back-btn-row {
    display: flex;
    justify-content: flex-end;
    margin-right: 2rem;
    margin-bottom: 10px;
}
.top-action-bar .el-button {
    border-radius: 6px;
    font-weight: 500;
    letter-spacing: 0.5px;
    transition: all 0.25s ease;
}
.top-action-bar .el-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* ========== Descriptions Table ========== */
/deep/ .el-descriptions {
    border-radius: 4px;
    overflow: hidden;
}
/deep/ .el-descriptions.is-bordered .el-descriptions-item__cell {
    padding: 10px 14px;
    transition: background-color 0.2s ease;
}
/deep/ .el-descriptions.is-bordered .el-descriptions-item__cell:hover {
    background-color: #f5f7fa;
}
/deep/ .el-descriptions .el-descriptions-item__label {
    font-weight: 600;
    color: #303133;
    background: #fafbfc;
}
/deep/ .el-descriptions .el-descriptions-item__content {
    color: #606266;
}

/* ========== Form Elements ========== */
.el-form-item {
    margin-bottom: 0;
}
/deep/ .el-form-item__label {
    line-height: 32px;
    width: 6rem;
    font-weight: 600;
    color: #303133;
}
.el-form-item__content {
    line-height: 32px;
}

/* ========== Input / Select / Cascader ========== */
/deep/ .el-input__inner {
    border-radius: 4px;
    transition: border-color 0.25s ease, box-shadow 0.25s ease;
}
/deep/ .el-cascader .el-input__inner {
    border-radius: 4px;
    transition: border-color 0.25s ease, box-shadow 0.25s ease;
}
/deep/ .el-select .el-input__inner {
    border-radius: 4px;
    transition: border-color 0.25s ease, box-shadow 0.25s ease;
}
/deep/ .el-input__inner:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
}
/deep/ .el-cascader .el-input__inner:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
}
/deep/ .el-select .el-input__inner:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
}

/* ========== Buttons ========== */
/deep/ .el-button--primary {
    border-radius: 6px;
    font-weight: 500;
    letter-spacing: 0.5px;
    transition: all 0.25s ease;
}
/deep/ .el-button--primary:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.35);
}
/deep/ .el-button--danger {
    border-radius: 6px;
    font-weight: 500;
    letter-spacing: 0.5px;
    transition: all 0.25s ease;
}
/deep/ .el-button--danger:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(245, 108, 108, 0.35);
}

/* ========== Form Button Row ========== */
.form-btn-row {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-bottom: 20px;
    margin-top: 1rem;
}

/* ========== Submit Button Row ========== */
.submit-btn-row {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin: 20px 0;
    padding-top: 16px;
    border-top: 1px solid #ebeef5;
}

/* ========== Divider ========== */
/deep/ .el-divider__text {
    background-color: #fff;
    font-weight: 600;
    color: #409eff;
    font-size: 14px;
}

/* ========== Switch ========== */
/deep/ .el-switch.is-checked .el-switch__core {
    border-color: #409eff;
    background-color: #409eff;
}

/* ========== Upload ========== */
.upclass >>> .el-upload-list {
    margin-left: 3rem;
}

/* ========== Misc ========== */
.message_box_alert {
    word-break: break-all !important;
}

.tableTitle {
    position: relative;
    margin: 30px auto;
    width: 90%;
    height: 2px;
    background-color: #d4d4d4;
    text-align: center;
    font-size: 16px;
    color: rgba(101, 101, 101, 1);
}
.midText {
    position: absolute;
    left: 50%;
    background-color: #ffffff;
    padding: 0 15px;
    transform: translateX(-50%) translateY(-50%);
}

.companyRow {
    line-height: 32px;
}
.remark >>> .el-form-item__content {
    width: 100%;
}

.uneditable-textarea .el-textarea__inner {
    background-color: #f2f2f2;
    color: #606266;
    border-color: #dcdfe6;
    cursor: not-allowed;
    -webkit-user-select: text;
    user-select: text;
    overflow: auto;
}

/deep/ .el-descriptions--medium.is-bordered .el-descriptions-item__cell {
    padding: 0;
}

/* ========== Responsive: Mobile ========== */
@media (max-width: 768px) {
    .section {
        height: 40px;
        border-radius: 4px;
        padding-left: 12px;
        margin: 6px 0 14px;
    }
    .section .title {
        font-size: 14px;
        gap: 6px;
    }
    .section .title i {
        font-size: 15px;
    }
    .card-container {
        padding: 12px 8px;
        margin: 10px 0 16px;
        border-radius: 6px;
    }
    .top-action-bar {
        margin-top: 0;
        justify-content: center;
    }
}

</style>